export default __webpack_public_path__ + "static/media/logoactivab.cba96cad.png";